export const QUERY_KEYS = {
  OE_PERIOD_LIST: "OE_PERIOD_LIST",
  CARRIER_LIST: "carrierList",
  CARRIER_TYPE_LIST: "carrierTypeList",
  CARRIER_READINESS_LIST: "carrierReadinessList",
  CARRIER_READINESS_AUDIT: "carrierReadinessAudit",
  CARRIER_TERMINATED_PLANS: "carrierTerminatedPlans",
  IMPORT_LIST: "importList",
  IMPORT_PAGE: "importPage",
  IMPORT_SUMMARY_LIST: "importSummaryList",
  IMPORT_ITEM: "importItem",
  IMPORT_ERRORS: "importErrors",
  IMPORT_SUBMIT_ERRORS: "importSubmitErrors",
  IMPORT_RATES: "importRates",
  IMPORT_FINAL_RATES: "importFinalRates",
  IMPORT_FINAL_RATES_EXPORT: "importFinalRatesExport",
  IMPORT_PLANMAPPING_LIST: "importPlanMapping",
  IMPORT_RATEGROUPMAPPING_LIST: "importRateGroupMapping",
  IMPORT_COSTS_LIST: "importCosts",
  IMPORT_PLANGROUPS_LIST: "importPlanGroups",
  PLAN_MAPPING_LIST: "planMappingList",
  PLAN_MAPPING_PAGE: "planMappingPage",
  RATE_GROUP_MAP_LIST: "rateGroupMapList",
  RATE_GROUP_MAP_PAGE: "rateGroupMapPage",
  PLAN_LIST: "planList",
  PLAN_DETAIL_LIST: "planDetailList",
  PLAN_DETAIL_PAGE: "planDetailPage",
  SYSTEM_MENU_FILTERS: "systemMenuFilters",
  PLAN_MAPPING_STATUS: "planMappingStatus",
  PLAN_RATES_GET: "PlanRateGet",
  PLAN_LIST_FOR_MAPPING: "planListForMapping",
  GET_USER: "getUser",
  GET_CLIENTS: "getClients",
  GET_CLIENTS_STATUS_REPORT: "getClientsStatusReport",
  GET_PARENT_RENEWAL_PAGE: "GET_PARENT_RENEWAL_PAGE",
  GET_CLIENT: "getClient",
  GET_CLIENT_BROKER: "getClientBroker",
  GET_CLIENT_BENEFIT_REP: "getClientBenefitRep",
  GET_CLIENT_SALES_REP: "getClientSalesRep",
  GET_CLIENTS_ACTIVE_OE: "getClientsActiveOE",
  GET_CLIENT_MODEL_VERSIONS: "getClientModelVersions",
  GET_CLIENT_MODEL_SUMMARY: "getClientModelSummary",
  GET_CLIENT_MODEL_AVAILABLE_PLANS: "getClientModelAvailablePlans",
  GET_CLIENT_MODEL_DETAIL: "getClientModelDetail",
  GET_CLIENT_PLANS: "getClientPlans",
  GET_CLIENT_MODEL_ERRORS: "getClientModelErrors",
  RATE_GROUP_MAPPING_LIST: "rateGroupMappingList",
  BENEFIT_GROUP_MAPPING_PAGE: "benefitGroupMappingPage",
  GET_CLIENT_MODEL_MAXCONTRIBS: "getClientModelMaxContribs",
  GET_CLIENT_AUDIT_RECORDS: "getClientModelAuditRecords",
  GET_CLIENT_SUBMISSION_RECORD: "getClientSubmissionRecord",
  OE_WORKFLOW_GET: "OEWorkFlowGet",
  OE_WORKFLOW_CLIENTS_GET: "OEWorkFlowClientsGet",
  OE_WORKFLOW_CLIENT_RATE_GROUPS_GET: "OEWorkFlowClientRateGroupsGet",
  OE_WORKFLOW_SETUP_GET: "OEWorkFlowSetupGet",
  OE_DATA_SYNC_ERROR_LOGS: "OEDataSyncErrorLogs",
  OE_DATE_SYNC_HISTORY: "OEDataSyncHistory",
  OE_WORKFLOW_DASHBAORD_SUMMARY: "OEWorkFlowDashboardSummary",
  OE_WORKFLOW_DASHBAORD_EXPORT: "OEWorkFlowDashboardExport",
  CLIENT_ADMIN_CONTACT_LIST: "clientAdminContactList",
  CLIENT_ADMIN_BENEFITGROUP_LIST: "clientAdminBenefitGroupList",
  CLIENT_ADMIN_BENEFITPLAN_LIST: "clientAdminBenefitPlanList",
  CLIENT_ADMIN_BENEFITRULES_GET: "clientAdminBenefitRulesList",
  CLIENT_MASTER_LIST: "clientMasterList",

  CLIENT_ADMIN_NOTIFICATION_HISTORY: "clientAdminNotificationHistory",
  CLIENT_ADMIN_MENU_DOCUMENT: "clientAdminMenuDocument",
  CLIENT_ADMIN_MENU_All: "clientAdminMenuAll",
  CLIENT_CURRENT_BENEFIT_PLANS: "clientCurrentBenefitPlans",
  CLIENT_ADMIN_MENU_BASE_ALL: "clientAdminMenuBaseAll",
  CLIENT_AETNA_COMPARE_PLANS: "clientAetnaComparePlans",
  CLIENT_AETNA_COMPARE_MODEL_PLANS: "clientAetnaCompareModelPlans",
  CLIENT_ADMIN_MENU_FIELD_OVERRIDES: "clientAdminMenuFieldOverrides",
  CLIENT_ADMIN_RATE_BAND_OVERRIDES: "clientAdminRateBandOverrides",
  CLIENT_ADMIN_RATE_BAND_OVERRIDES_HISTORY:
    "clientAdminRateBandOverridesHistory",

  CLIENT_ADMIN_EMP_MENU_DOCUMENT: "clientAdminEmpMenuDocument",

  CLIENT_ADMIN_MAINTENANCE: "clientAdminMaintenance",
  CLIENT_ADMIN_GET_LATEST_MAINTENANCE: "clientAdminGetLatestMaintenance",

  NOTIFICATION_WAVES_LIST: "notificationWavesList",
  NOTIFICATION_WAVE_CLIENTS: "notificationWaveClients",
  NOTIFICATION_WAVE_MAIL_DETAILS: "notificationWaveMailDetails",
  NOTIFICATION_WAVE_AVAILABLE_CLIENTS: "notificationWaveAvailableClients",
  NOTIFICATION_WAVE_BENEFIT_GROUPS: "notificationWaveBenefitGroups",
  NOTIFICATION_WAVE_ERRORS: "notificationWaveErrors",

  NOTIFICATION_REDIRECT_LIST: "notificationRedirectList",

  NOTIFICATION_REMINDER_LIST: "notificationReminderList",
  FLEX_CONTRIBUTION_LIMITS: "flexContributionLimits",

  NOTIFICATION_INDIVIDUAL_CLIENTS: "notificationIndividualClients",
  NOTIFICATION_BROKER_CLIENTS: "notificationBrokerClients",
  NOTIFICATION_WAVE_REMINDERS: "notificationWaveReminders",

  BROKER_USER_LIST: "BrokerUserList",
  BROKER_USER_PAGE: "BrokerUserPage",
  BROKER_USER_CLIENTS: "BrokerUserClients",

  BROKER_IMPORT_LIST: "BrokerImportList",
  BROKER_IMPORT_BATCH: "BrokerImportBatch",

  BROKER_COMMS_TEMPLATES: "brokerCommsTemplates",
  BROKER_COMMS_WAVE_CARRIERS: "brokerCommsWaveCarriers",
  BROKER_COMMS_AUDIT: "brokerCommsAudit",

  GET_CLIENT_DISCLOSURE_STATUS: "getClientDisclosureStatus",

  CLIENT_RATE_MODEL_MEDICAL_CARRIERS: "clientRateModelMedicalCarriers",
  CLIENT_RATE_MODEL_SUBMIT_CARRIER_RULE: "clientRateModelSubmitCarrierRule",

  FEATURE_ACCESS_LIST: "featureAccessList",
  FEATURE_ACCESS_KEYS: "featureAccessKeys",
  FEATURE_ACCESS_ENABLED: "featureAccessEnabled",
  FEATURE_ACCESS_ENABLED_ANY: "featureAccessEnabledAny",
  PORTAL_SETTING_BLOCKED_MESSAGE: "portalSettingBlockedMessage",
  REPORT_EXCLUSION_LIST: "reportExclusionList",

  SALES_ADMIN_MAPPING_LIST: "salesAdminMappingList",
  PRISM_INTERNAL_USERS: "prismInternalUsers",

  CLIENT_AETNA_MAPPING_LIST: "clientAetnaMappingList",
  CLIENT_AETNA_MAPPING_CLIENT: "clientAetnaMappingClient",
};
